<template>
	<div class="column">
		<div>
			<div class="subtitle">Lägg till {{ title }}</div>
			<div class="field" v-if="tab !== 0">
				<label class="label">Sök</label>
				<div class="control">
					<input
						type="text"
						class="input"
						:placeholder="'Sök ' + title"
						v-model="searchValue"
						@input="search"
						@keyup.esc="clearSearch"
					/>
				</div>
			</div>
			<div class="field" v-else>
				<label class="label">Byggnad</label>
				<div class="control">
					<v-select
						class="panel-select header"
						v-model="selectedBuilding"
						:options="buildings"
						:placeholder="'Välj byggnad'"
						:allowEmpty="false"
						:internalSearch="false"
						:showLabels="false"
						@search-change="searchBuildings"
						@select="changeBuilding"
						track-by="id"
						label="name"
					>
						<span slot="noResult">Inga resultat</span>
						<span
							slot="caret"
							slot-scope="{ toggle }"
							class="caret"
							@mousedown.prevent.stop="toggle()"
						><i class="fas fa-caret-down caret-inner"></i
						></span>
					</v-select>
				</div>
			</div>
		</div>
		<div
			class="panel-list narrow no-hover"
			v-for="item in listItems"
			:key="item.id"
		>
			<p class="panel-list-item">{{ item.name }}</p>
			<span class="icon" @click="addItem(item)">
				<i class="fas fa-plus"></i>
			</span>
		</div>
		<div class="panel-list narrow no-hover" v-if="listItems.length == 0">
			<p class="header-item">Inga resultat</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		listItems: Array,
		title: String,
		tab: Number,
		buildings: Array
	},
	data() {
		return {
			searchValue: '',
			selectedBuilding: {}
		};
	},
	watch: {
		tab: {
			handler: function() {
				this.clearSearch();
			}
		}
	},
	methods: {
		addItem(item) {
			this.$emit('addItem', item);
		},
		search() {
			this.$emit('search', this.searchValue);
		},
		clearSearch() {
			this.searchValue = '';
			this.search();
		},
		changeBuilding(building) {
			this.$emit('changeBuilding', building);
		},
		searchBuildings(value) {
			this.$emit('searchBuildings', value);
		}
	},
	created() {
		this.selectedBuilding = this.buildings[0];
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.subtitle {
  min-width: 130px;
  padding-top: 10px;
  margin-bottom: 0.5rem !important;
  font-weight: 600;
}

.label {
  font-size: 12px;
}

.field {
  border-bottom: 1px solid $lightest-grey;
  padding-bottom: 15px;
  margin-bottom: 15px;
  margin: 10px;
  .input {
    background: white;
    max-width: 300px;
  }
}
</style>

<style lang="scss">
@import "@/assets/colors.scss";

.multiselect.panel-select.header {
  max-width: 300px;
  .caret {
    background-color: #fcfcfc;
  }
  .multiselect__tags {
    background-color: white;

    .multiselect__single,
    .multiselect__input {
      background-color: white;
    }
  }
  .multiselect__content {
    background: white;
  }
}
</style>
